<template>
  <div class="layout-sidebar" @click="onMenuClick">
    <router-link to="/" class="logo">
      <img
        id="app-logo"
        class="logo-image"
        src="/assets/layout/images/logo.png"
        alt="reply"
      />
    </router-link>

    <div class="layout-menu-container">
      <AppSubmenu
        :items="model"
        :layoutMode="layoutMode"
        :parentMenuItemActive="true"
        :menuActive="active"
        :mobileMenuActive="mobileMenuActive"
        :root="true"
        @menuitem-click="onMenuItemClick"
        @root-menuitem-click="onRootMenuItemClick"
      />
      <p class="mt-6">
        <LocaleChanger customclass="rightbar-local-changer" />
      </p>
    </div>
  </div>
</template>

<script>
import LocaleChanger from "./components/LocaleChanger.vue";
import AppSubmenu from "./AppSubmenu";
export default {
  name: "AppMenu",
  emits: ["menu-click", "menuitem-click", "root-menuitem-click"],
  props: {
    model: Array,
    layoutMode: String,
    active: Boolean,
    mobileMenuActive: Boolean,
  },
  methods: {
    onMenuClick(event) {
      this.$emit("menu-click", event);
    },
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
    onRootMenuItemClick(event) {
      this.$emit("root-menuitem-click", event);
    },
  },
  components: { AppSubmenu, LocaleChanger },
};
</script>

<style>
.layout-sidebar .logo-image {
  width: auto;
  height: auto;
}
.layout-sidebar-darkgray .layout-sidebar {
  background: #f0f2f4;
  box-shadow: 2px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 0px 40px 40px 0px;
}
</style>
